import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';

export default LaunchRoundedIcon;
